import { Action, createReducer, on } from '@ngrx/store';
import { IGenericError, ErrorResponse } from '../../../core/models/generic-models';
import { updateMemberDetail, updateMemberDetailSuccess, updateMemberDetailFailure } from '../actions/member-detail.actions';
import { IUpdateMemberDetailRequest, IUpdateMemberDetailResponse } from '../models/member-detail.model';

export const updateMemberDetailFeatureKey = 'updateMemberDetail';

export interface UpdateMemberDetailState {
  updateMemberDetailRequest: IUpdateMemberDetailRequest | undefined;
  updateMemberDetailResponse: IUpdateMemberDetailResponse | undefined;
  updateMemberDetailFailure: IGenericError<ErrorResponse> | undefined;
}

export const initialState: UpdateMemberDetailState = {
  updateMemberDetailRequest: undefined,
  updateMemberDetailResponse: undefined,
  updateMemberDetailFailure: undefined
};

export const reducer = createReducer(
  initialState,

  on(updateMemberDetail, (state, action) => ({
    ...state,
    updateMemberDetailRequest: action.request
  })),
  on(updateMemberDetailSuccess, (state, action) => ({
    ...state,
    updateMemberDetailResponse: action.response
  })),
  on(updateMemberDetailFailure, (state, action) => ({
    ...state,
    updateMemberDetailFailure: action.error
  }))
);

export const getUpdateMemberDetailRequest = (state: UpdateMemberDetailState) => state.updateMemberDetailRequest;
export const getUpdateMemberDetailResponse = (state: UpdateMemberDetailState) => state.updateMemberDetailResponse;
export const getUpdateMemberDetailFailure = (state: UpdateMemberDetailState) => state.updateMemberDetailFailure;
